import React from "react";
import { Tooltip } from "@mui/material";
import {
  IconSynchronousExecutionSvg,
  IconLongRunningJobWorkerSvg,
  IconNormalJobWorkerSvg,
} from "../../../common/utils/icons";
import { useThemeMode } from "../../../contexts/ThemeModeContext";
import { brand } from "../../../styles/Theme";

interface ExecutionModeIconProps {
  executionMode: string;
}

const ExecutionModeIcon: React.FC<ExecutionModeIconProps> = ({
  executionMode,
}) => {
  const { mode } = useThemeMode();
  // brand.navy (#0E1223) on the light table surface; brand.ice (#d7f1ff) on
  // the dark table surface — both achieve WCAG AA contrast (≥4.5:1).
  const iconColor = mode === "dark" ? brand.ice : brand.navy;

  const getExecutionModeIcon = (executionMode: string) => {
    switch (executionMode) {
      case "synchronous":
        return (
          <Tooltip title="Synchronous Execution" placement="top" arrow>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <IconSynchronousExecutionSvg color={iconColor} />
            </div>
          </Tooltip>
        );
      case "long_running_job_worker":
        return (
          <Tooltip title="Long Running Job Worker" placement="top" arrow>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <IconLongRunningJobWorkerSvg color={iconColor} />
            </div>
          </Tooltip>
        );
      case "normal_job_worker":
        return (
          <Tooltip title="Normal Job Worker" placement="top" arrow>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <IconNormalJobWorkerSvg color={iconColor} />
            </div>
          </Tooltip>
        );
      default:
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <span>-</span>
          </div>
        );
    }
  };

  return getExecutionModeIcon(executionMode);
};

export default ExecutionModeIcon;
